// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FeedPostDeleteModal{max-width:600px;width:100%}", "",{"version":3,"sources":["webpack://./components/FeedPostDeleteModal/index.sass"],"names":[],"mappings":"AACA,qBACE,eAAA,CACA,UAAA","sourcesContent":["\n.FeedPostDeleteModal\n  max-width: 600px\n  width: 100%"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
